import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Chip,
} from "@mui/material";

import { auth, db } from "../firebase";

import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  doc,
  getDoc,
} from "firebase/firestore";

import { onAuthStateChanged } from "firebase/auth";

function Switchlogs() {
  const [propertyId, setPropertyId] = useState(null);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  /*
  ===============================
  1️⃣ Get propertyId from authRoles
  ===============================
  */

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const roleRef = doc(db, "authroles", user.uid);
        const roleSnap = await getDoc(roleRef);

        if (roleSnap.exists()) {
          const roleData = roleSnap.data();

          if (roleData.propertyId) {
            setPropertyId(roleData.propertyId);
          } else {
            console.log("propertyId not found in authRoles");
            setLoading(false);
          }
        } else {
          console.log("authRoles document not found");
          setLoading(false);
        }
      } catch (error) {
        console.log("Error fetching propertyId:", error);
        setLoading(false);
      }
    });

    return () => unsubscribeAuth();
  }, []);

  /*
  ===============================
  2️⃣ Fetch Switch Logs
  ===============================
  */

  useEffect(() => {
    if (!propertyId) return;

    try {
      const q = query(
        collection(db, "tableChangeLogs"),
        where("propertyId", "==", propertyId),
        orderBy("createdAt", "desc")
      );

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          const list = [];

          snapshot.forEach((doc) => {
            list.push({
              id: doc.id,
              ...doc.data(),
            });
          });

          setLogs(list);
          setLoading(false);
        },
        (error) => {
          console.log("Snapshot Error:", error);
          setLoading(false);
        }
      );

      return () => unsubscribe();
    } catch (error) {
      console.log("Query Error:", error);
      setLoading(false);
    }
  }, [propertyId]);

  /*
  ===============================
  UI
  ===============================
  */

  return (
    <Box sx={{ p: 3 }}>
      <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Table Switch Logs
          </Typography>

          {loading ? (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </Box>
          ) : logs.length === 0 ? (
            <Typography>No Logs Found</Typography>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Sr No</b>
                  </TableCell>
                  <TableCell>
                    <b>Old Table</b>
                  </TableCell>
                  <TableCell>
                    <b>New Table</b>
                  </TableCell>
                  <TableCell>
                    <b>Note</b>
                  </TableCell>
                  <TableCell>
                    <b>Date</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {logs.map((log, index) => (
                  <TableRow key={log.id}>
                    <TableCell>{index + 1}</TableCell>

                    <TableCell>
                      <Chip
                        label={log.oldTableName || "-"}
                        color="error"
                        size="small"
                      />
                    </TableCell>

                    <TableCell>
                      <Chip
                        label={log.newTableName || "-"}
                        color="success"
                        size="small"
                      />
                    </TableCell>

                    <TableCell>{log.note || "-"}</TableCell>

                    <TableCell>
                      {log.createdAt
                        ? log.createdAt.toDate().toLocaleString()
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}

export default Switchlogs;